import React, {Component} from 'react'
import classNames from 'classnames';
import CheckBoxItem from './CheckBoxItem'

export default ({onToggle, data, active, id, questionNumber}) => {
  const handleChange = event => {
    onToggle(active, Object.assign({}, data, {
      other: true,
      otherValue: event.target.value,
      text: event.target.value,
      freeText: event.target.value
    }))
  }
  
  return (
    <CheckBoxItem
      onToggle={onToggle}
      data={data}
      active={active}
      id={id}
      questionNumber={questionNumber}
    >
      <input
        className={classNames(
          'checkbox-free-text',
          {'active': active}
        )}
        onChange={handleChange}
        type="input"
        placeholder='Please list other reasons here...'
      />
    </CheckBoxItem>
  )
}
